common.View.create('crud::form.inputs.Time', {

	/**
	 * Called when DOM is ready.
	 */
	onDOMLoad()
	{
		this.initGUI();
	},

	/**
	 * Initializes the Datetime picker.
	 */
	initGUI()
	{
		this.element

			.find('input:not([readonly])')
                .flatpickr({
                    locale: 'nl',
                    "dateFormat": "H:i",
                    noCalendar: true,
                    "enableTime": true,
                    "time_24hr": true,
                    allowInput: !$(this.element).is('[disabled]'),
                });
	},

});
